import { render, staticRenderFns } from "./OpenApp.vue?vue&type=template&id=1947f500&scoped=true"
import script from "./OpenApp.vue?vue&type=script&lang=js"
export * from "./OpenApp.vue?vue&type=script&lang=js"
import style0 from "./OpenApp.vue?vue&type=style&index=0&id=1947f500&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1947f500",
  null
  
)

export default component.exports